import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { BRAND } from '../../constants/branding';
import { AurieqLogo } from '../../components/Brand/AurieqLogo';
import { gradientButtonSx } from '../../constants/brandStyles';

export const NotFoundPage: React.FC = () => (
  <Container maxWidth="sm" sx={{ py: 12, textAlign: 'center' }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3, opacity: 0.6 }}>
      <AurieqLogo variant="mark" height={64} to={false} />
    </Box>
    <Typography variant="h1" fontWeight={800} sx={{ fontSize: '5rem', background: BRAND.gradient, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
      404
    </Typography>
    <Typography variant="h5" fontWeight={700} gutterBottom>
      Page not found
    </Typography>
    <Typography sx={{ mb: 4, color: BRAND.colors.textDim }}>
      The page you&apos;re looking for doesn&apos;t exist on {BRAND.name}.
    </Typography>
    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
      <Button component={RouterLink} to="/" variant="contained" sx={gradientButtonSx}>
        Go home
      </Button>
      <Button
        component={RouterLink}
        to="/dashboard"
        variant="outlined"
        sx={{ borderColor: BRAND.colors.border, color: BRAND.colors.text }}
      >
        Dashboard
      </Button>
    </Box>
  </Container>
);

export default NotFoundPage;
